import React from 'react';
import heroBgImage from '../assets/hero-background.jpg';

const Hero = () => {
    const heroStyle = {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${heroBgImage})`
    };

    return (
        <section id="hero" className="hero" style={heroStyle}>
            <div className="hero-content">
                <div className="hero-badge-pill">
                    <span className="dot"></span> Artisan Électricien • Le Tampon & Sud Réunion
                </div>
                <h1>Entreprise d'Électricité &amp; Dépannage à La Réunion</h1>
                <h2>TechniServices : votre artisan électricien de confiance au Tampon et ses environs. Dépannage rapide, mises aux normes NF C 15-100 et domotique.</h2>
                <div className="hero-buttons">
                    <a href="#services" className="btn">Mes Services</a>
                    <a href="#devis" className="btn secondary">Demander un Devis</a>
                </div>
            </div>
        </section>
    );
};

export default Hero;